// =============================================================================
// 3. UploadTrialBalanceButton.js
// src/components/RPA/buttons/UploadTrialBalanceButton.js
// =============================================================================
import React, { useState, useRef } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

export default function UploadTrialBalanceButton({ docId, onDone, disabledHint }) {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !docId) return;

    setLoading(true);
    try {
      const formData = new FormData();

      // 👇 MUST match multer.single('trialBalance') in uploadTrialBalanceController
      formData.append('trialBalance', file);
      formData.append('docId', docId);

      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/trial-balance/upload`,
        formData,
        {
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      );

      console.log('[UPLOAD_TRIAL_BALANCE_BTN] Success:', res.data);

      // RpaDashboard's onDone will schedule a debounced fetchDocs() refresh
      if (onDone) onDone(res.data);
    } catch (err) {
      console.error('[UPLOAD_TRIAL_BALANCE_BTN] Failed:', err);
      alert(err.response?.data?.message || 'Trial balance upload failed');
    } finally {
      setLoading(false);
      // reset file input so you can re-upload the same file if needed
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <div style={{ display: 'inline-block' }}>
      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx,.xls,.csv"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />
      <button
        onClick={() => fileInputRef.current?.click()}
        disabled={loading || !!disabledHint}
        title={disabledHint || 'Upload trial balance (XLSX/XLS/CSV)'}
        style={{
          background: loading ? '#9ca3af' : (disabledHint ? '#fca5a5' : '#f59e0b'),
          color: 'white',
          border: 'none',
          padding: '4px 8px',
          borderRadius: 4,
          fontSize: 11,
          cursor: loading || disabledHint ? 'not-allowed' : 'pointer',
          fontWeight: 500
        }}
      >
        {loading ? 'Uploading…' : 'Upload Trial Balance'}
      </button>
    </div>
  );
}






// // =============================================================================
// // 3. UploadTrialBalanceButton.js
// // src/components/RPA/buttons/UploadTrialBalanceButton.js
// // =============================================================================
// import React, { useState, useRef } from 'react';
// import axios from 'axios';

// const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

// export default function UploadTrialBalanceButton({ docId, onDone, disabledHint }) {
//   const [loading, setLoading] = useState(false);
//   const fileInputRef = useRef(null);

//   const handleFileSelect = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file || !docId) return;

//     setLoading(true);

//     try {
//       const formData = new FormData();

//       // 👇 MUST match multer.single('trialBalance') in the backend
//       formData.append('trialBalance', file);

//       // Helpful context for the controller (even if it mostly uses req.params)
//       formData.append('docId', docId);
//       formData.append('docType', 'trial_balance');

//       const url = `${API_URL}/admin/rpa/docs/${docId}/trial-balance/upload`;

//       const response = await axios.post(url, formData, {
//         withCredentials: true,
//         headers: {
//           'Content-Type': 'multipart/form-data'
//         }
//       });

//       if (response?.data?.success === false) {
//         console.error('[UploadTrialBalanceButton] Upload failed:', response.data);
//         window.alert(response.data.message || 'Trial balance upload failed');
//       } else {
//         console.log('[UploadTrialBalanceButton] Upload success:', response.data);
//         if (typeof onDone === 'function') {
//           onDone(response.data);
//         }
//       }
//     } catch (err) {
//       console.error('[UploadTrialBalanceButton] Error uploading trial balance:', err);
//       window.alert('Error uploading trial balance. Please try again.');
//     } finally {
//       setLoading(false);
//       if (fileInputRef.current) {
//         fileInputRef.current.value = '';
//       }
//     }
//   };

//   const handleClick = () => {
//     if (loading || disabledHint) return;
//     if (fileInputRef.current) {
//       fileInputRef.current.click();
//     }
//   };

//   return (
//     <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}>
//       {/* Hidden file input */}
//       <input
//         ref={fileInputRef}
//         type="file"
//         accept=".xlsx,.xls,.csv"
//         style={{ display: 'none' }}
//         onChange={handleFileSelect}
//       />

//       {/* Optional disabled reason */}
//       {disabledHint && (
//         <div
//           style={{
//             fontSize: 11,
//             color: '#b91c1c',
//             marginBottom: 2,
//             maxWidth: 260
//           }}
//         >
//           {disabledHint}
//         </div>
//       )}

//       {/* Visible button */}
//       <button
//         type="button"
//         onClick={handleClick}
//         disabled={loading || !!disabledHint}
//         style={{
//           background: loading ? '#9ca3af' : (disabledHint ? '#fca5a5' : '#f59e0b'),
//           color: 'white',
//           border: 'none',
//           padding: '4px 8px',
//           borderRadius: 4,
//           fontSize: 11,
//           cursor: loading || disabledHint ? 'not-allowed' : 'pointer',
//           fontWeight: 500,
//           display: 'inline-flex',
//           alignItems: 'center',
//           gap: 6
//         }}
//       >
//         {loading ? 'Uploading…' : 'Upload Trial Balance'}
//       </button>
//     </div>
//   );
// }
